import styled, { keyframes } from "styled-components";
import { tableHeaderTextCss } from "../../../../components/atoms/Table/tableTypography.styles";
import { Select } from "antd";

// ============================================================================
// Shared Keyframes
// ============================================================================
export const spin = keyframes`
  to { transform: rotate(360deg); }
`;

// ============================================================================
// SortDropdown Styles
// ============================================================================
export const SortOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const SortDropdownPanel = styled.div`
  position: absolute;
  z-index: 1000;
  top: calc(100% + 4px);
  left: 0;
  min-width: 160px;
  padding: 4px 0;
  border-radius: 6px;
  border: 1px solid var(--PEARL, #ecf1f4);
  background: #ffffff;
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 14px;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: var(--DARK-GREY, #0e0e2c);
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s;

  &:hover {
    color: #1249bf;
  }

  &.active {
    color: #1249bf;
    font-weight: 500;
  }

  &.reset {
    color: #6b7280;
    border-top: 1px solid #f0f1f3;
    margin-top: 2px;
    padding-top: 8px;
  }
  &.reset:hover {
    color: #ef4444;
  }
`;

// ============================================================================
// FilterDropdown Styles
// ============================================================================
export const FilterOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const FilterDropdownPanel = styled.div`
  position: absolute;
  z-index: 1000;
  top: calc(100% + 4px);
  left: 0;
  width: 260px;
  border-radius: 6px;
  border: 1px solid var(--PEARL, #ecf1f4);
  background: #ffffff;
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px 8px;
  background: #f9fafd;
  border-bottom: 1px solid #e9edf5;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #0e0e2c;
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  display: flex;
  align-items: center;
  &:hover {
    color: #0e0e2c;
  }
`;

export const PanelBody = styled.div`
  padding: 12px 14px;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  font-family: Inter, sans-serif;
  font-size: 13px;

  .ant-select-selector {
    border-radius: 6px !important;
    border: 1px solid #c5c7d0 !important;
    font-size: 13px !important;
    min-height: 32px !important;
    padding: 2px 8px !important;
  }

  .ant-select-selection-item-content {
    font-size: 12px;
    font-family: Inter, sans-serif;
  }

  .ant-select-selection-placeholder {
    font-size: 13px;
    color: #b9b9c6;
  }

  &.ant-select-focused .ant-select-selector {
    border-color: #1249bf !important;
    box-shadow: 0 0 0 2px rgba(18, 73, 191, 0.1) !important;
  }
`;

export const SelectAllRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 6px 10px;
  font-size: 13px;
  font-family: Inter, sans-serif;
  color: #4a4a68;
  cursor: pointer;
  border-bottom: 1px solid #f0f1f3;

  &:hover {
    background: #f9fafd;
  }

  input[type="checkbox"] {
    accent-color: #1249bf;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;

  color: var(--GREY, #4a4a68);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;

  input[type="checkbox"] {
    accent-color: #1249bf;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
`;

export const OptionsListContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9edf5;
  border-radius: 6px;
  margin-top: 8px;
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 14px 12px;
  border-top: 1px solid #f0f1f3;
`;

export const CancelBtn = styled.button`
  padding: 4px 14px;
  background: #f7f8f9;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 13px;
  font-family: Inter, sans-serif;
  cursor: pointer;
  &:hover {
    background: #eef0f3;
  }
`;

export const ApplyBtn = styled.button`
  padding: 4px 14px;
  background: ${props => (props.$active ? "#2060ea" : "#f7f8f9")};
  color: ${props => (props.$active ? "#ffffff" : "rgba(0,0,0,0.25)")};
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-family: Inter, sans-serif;
  cursor: ${props => (props.$active ? "pointer" : "not-allowed")};
  transition: background 0.15s;
`;

// ============================================================================
// InfiniteScrollTable Styles
// ============================================================================
export const LoadingRow = styled.tr`
  height: 48px;
`;

export const LoadingCell = styled.td`
  text-align: center;
  padding: 12px 0;
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #e9edf5;
  border-top-color: #4b6ef5;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

export const EmptyRow = styled.tr`
  height: 80px;
`;

export const EmptyCell = styled.td`
  text-align: center;
  color: #9da3b4;
  font-size: 13px;
  font-family: Inter, sans-serif;
  height: 300px;
`;

export const SentinelRow = styled.tr`
  height: 1px;
  visibility: hidden;
`;

export const HeaderCellWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
  z-index: 5;
  user-select: none;
`;

export const HeaderLabel = styled.span`
  white-space: nowrap;
`;

export const IconBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: ${props => (props.$active ? "#1249bf" : "#a0aec0")};
  transition: color 0.15s;
  &:hover {
    color: #1249bf;
  }
`;

export const CloseFilterPill = styled.span`
  display: flex;
  padding: 0px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: var(--Peach, #f3d9da);
  cursor: pointer;
`;

// ============================================================================
// Table Base Styles
// ============================================================================
export const StyledTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-bottom: 1px solid #e9edf5;
`;

export const StyledTable = styled.table`
  max-width: 100%;
  border-collapse: collapse;
  font-family: Inter, sans-serif;
  font-size: 14px;
`;

export const StyledTableHeader = styled.thead`
  position: sticky;
  top: 0;
  background-color: #ffffff;
  border-bottom: 1.6px solid var(--Gray-50, #e9edf5);
  z-index: 10;

  tr {
    height: 34px;
  }
`;

export const StyledHeaderColumn = styled.th`
  padding: 0 16px;
  ${tableHeaderTextCss}
  text-align: left;

  &.centerAlign {
    text-align: center;
  }
  &.rightAlign {
    text-align: right;
  }
`;

export const StyledTableRow = styled.tr`
  height: 48px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  background-color: #ffffff;
  border-bottom: 1px solid var(--Gray-50, #e9edf5);

  &:hover {
    background-color: #fcfdfe;
  }

  &:nth-child(even) {
    background-color: var(--CLOUD, #fcfdfe);
    border-top: 1px solid var(--Gray-50, #e9edf5);
    border-bottom: 1.6px solid var(--Gray-50, #e9edf5);
  }

  &.selectedRow {
    background-color: var(--Pearl, #ecf1f4);
  }
`;

export const StyledTableData = styled.td`
  padding: 0 16px;
  white-space: nowrap;

  &.centerAlign {
    text-align: center;
  }
  &.rightAlign {
    text-align: right;
  }
`;

export const HeaderCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  min-width: max-content;
  position: relative;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  color: #a0aec0;
  font-size: 10px;
`;
